// Should work for node and browser.
exports.resolve = function resolve(segments = []) {
  return segments
    .filter(Boolean)
    .join('/')
    .replace(/\/\/+/g, '/');
};
